import actions from '../actions/actions';
import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens

// responds to POST_NAME action
function postName(store, action) {
    /**
     * An example POST. The important thing here is the inclusion of the CSRF
     * token as a header on the request. We are using the `hapi-jwt-csrf' plugin
     * on the server to enable this workflow. The POST will fail if the token
     * is not included.
     *
     * Ideally, you'd create a generic api utility module that wraps superagent
     * and adds the CSRF token to all POSTs.
     */

    // Make api call and then dispatch once response comes back
    request.post('/temp/api/name')
        .send({
            name: action.payload.name
        })
        .end((error, response) => {
            if (error) {
                store.dispatch(actions.postNameError());
            } else {
                store.dispatch(actions.postNameSuccess(response));
            }
        });
}

export default postName;
